import L from "leaflet";

const MarkerIcon = (
    key,
    esControl = false,
) => {
    return L.divIcon({
        className: "custom-marker",
        html: `<div class="marker">
                                    <!-- Círculo y número en el centro -->
                                        <div class="marker-center ${esControl ? "marker-center-control" : "marker-center-stops"}">
                                            <div class="marker-number">${key + 1}</div>
                                        </div>
                                    <!-- Parte inferior de marcador (punta) -->
                                        <div class="marker-content-end"></div>
                                    </div>`,
        iconSize: [30, 41], // Tamaño del icono
        iconAnchor: [12, 41], // Punto de anclaje
    })
};

export default MarkerIcon